import React from 'react';
import { IconContainer, Facebook, Twitter } from '@icons/common';

interface ShareContainerProps {
  followText: string;
}

export const ShareContainer = ({ followText }: ShareContainerProps) => {
  return (
    <div className='l-share-buttons-container'>
      <span className='follow'>{followText}</span>
      <div className='l-share-buttons-container-links'>
        <div className='c-share-link is-facebook '>
          <a
            href='//www.facebook.com/pages/Alfa-Laval/171132542929029'
            title='Follow us on Facebook'
          >
            <IconContainer icon={<Facebook />} />
          </a>
        </div>
        <div className='c-share-link is-twitter'>
          <a href='//twitter.com/Alfa_Laval' title='Follow us on Twitter'>
            <IconContainer icon={<Twitter />} />
          </a>
        </div>
        <div className='c-share-link is-linkedin'>
          <a href='//www.linkedin.com/company/alfa-laval' title='Follow us on LinkedIn'>
            <i className='icon-linkedin' aria-hidden='true' />
          </a>
        </div>

        <div className='c-share-link is-youtube'>
          <a href='//www.youtube.com/user/alfalaval' title='Follow us on YouTube'>
            <i className='icon-youtube' aria-hidden='true' />
          </a>
        </div>
      </div>
    </div>
  );
};
